import * as Yup from "yup";
import { FIELD_REQUIRED_MESSAGE } from "../utils/validations";

export const logInInitialValues = {
  email: "",
  password: "",
};

export const logInValidationSchema = Yup.object({
  email: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  password: Yup.string().required(FIELD_REQUIRED_MESSAGE),
});

export type LogInValues = typeof logInInitialValues;
